import { NotificationGroup } from "./Enums";

export class Notification {
  ID: string;
  NAME: string;
  GROUP: NotificationGroup;
  SELECTED: boolean;

  static parse(json: any): Notification {
    if (json) {
      const n = new Notification();
      n.ID = json.ID;
      n.NAME = json.NAME;

      n.GROUP = NotificationGroup[<string>json.GROUP];
      n.SELECTED = json.SELECTED;

      return n;
    } else { return null; }
  }

  static parseArray(json: Array<any>): Array<Notification> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Notification.parse(j));

    return arr;
  }

}
